'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/modules/es6.string.sub.js
// module id = ../../../../core-js/modules/es6.string.sub.js
// module chunks = 0